import React, { useMemo } from 'react';
import './LoadingScreen.css';

/** Default augment art, mixed so neighbouring drops are not the same play. */
const RAIN_ICONS = [
  '/augments/match/2x/default.svg',
  '/augments/clash/sa/default.svg',
  '/augments/match/1goal/default.svg',
  '/augments/round/os/default.svg',
  '/augments/match/penalty/default.svg',
  '/augments/clash/bs/default.svg',
  '/augments/round/aon/default.svg',
  '/augments/match/red-card/default.svg',
  '/augments/clash/gd/default.svg',
  '/augments/round/gc/default.svg',
  '/augments/match/missed-pk/default.svg',
  '/augments/clash/eif/default.svg',
  '/augments/round/bus/default.svg',
  '/augments/match/b/default.svg',
  '/augments/round/sn/default.svg',
  '/augments/match/h/default.svg',
  '/augments/round/bl/default.svg',
  '/augments/match/s/default.svg',
  '/augments/match/d/default.svg',
  '/augments/match/m/default.svg'
];

const COLUMN_COUNT = 8;
const GLYPHS_PER_COLUMN = 8;

function columnGlyphs(column) {
  const glyphs = [];
  for (let i = 0; i < GLYPHS_PER_COLUMN; i += 1) {
    glyphs.push(RAIN_ICONS[(column * 5 + i * 3) % RAIN_ICONS.length]);
  }
  return glyphs;
}

function LoadingScreen({ fill = false }) {
  const columns = useMemo(
    () => Array.from({ length: COLUMN_COUNT }, (_, column) => columnGlyphs(column)),
    []
  );

  return (
    <div className={`sc-load${fill ? ' sc-load--fill' : ''}`} role="status" aria-label="Loading...">
      <div className="sc-load-rain" aria-hidden="true">
        {columns.map((glyphs, column) => {
          const duration = 5.2 + (column % 4) * 1.45 + (column % 3) * 0.55;
          return (
            <div
              key={column}
              className="sc-load-col"
              style={{
                animationDuration: `${duration}s`,
                animationDelay: `${-((column * 0.73) % duration)}s`
              }}
            >
              {[0, 1].map((copy) => (
                <div className="sc-load-stack" key={copy}>
                  {glyphs.map((src, index) => (
                    <img
                      key={`${copy}-${index}`}
                      src={src}
                      alt=""
                      className={`sc-load-glyph${index === glyphs.length - 1 ? ' sc-load-glyph--head' : ''}`}
                      style={{ opacity: 0.14 + (index / (glyphs.length - 1)) ** 1.7 * 0.86 }}
                    />
                  ))}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      <div className="sc-load-center">
        <p className="sc-load-word">
          <span className="sc-brand-score">Load</span>
          <span className="sc-brand-clash">ing...</span>
        </p>
      </div>
    </div>
  );
}

export default LoadingScreen;
